var map = {
	"./AmharicAI.png": 914,
	"./CourseRegistration.png": 148,
	"./GitHub-logo.png": 81,
	"./Icram_Doku.jpg": 178,
	"./LinkedIn-logo.png": 500,
	"./SimpleBudget.png": 947,
	"./SimplyCS.png": 593,
	"./TaskMeister.png": 843,
	"./WeightTracker.png": 704,
	"./devpost_logo_icon_169280.webp": 542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 409;